<template>
  <van-divider v-if="allTagInfos.length>0" style="margin:10px 0;"/>
  <div v-if="isShowTagFilter" class="tDoubleTagsParentDiv">
    <div style="display:flex;flex-direction: row;">
      <div v-if="allTagInfos.length>0" @click="pressRow1Tag(null)"
           :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select1RowItem === null?'eachTagActive':'']">全部
      </div>
      <div class="scrollable-tags">
        <div @click="pressRow1Tag(row1Item)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select1RowItem?.Id === row1Item.Id?'eachTagActive':'']"
             style="margin-left: 6px;" v-for="row1Item in allTagInfos" :key="row1Item.Id">
          {{ row1Item.Name }}
        </div>
      </div>
    </div>
    <div v-if="row2TagInfos!==null" style="margin:4px 0;"/>
    <div v-if="row2TagInfos!==null" style="display:flex;flex-direction: row;">
      <div @click="pressRow2Tag(null)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select2RowItem === null?'eachTagActive':'']">全部</div>
      <div class="scrollable-tags">
        <div @click="pressRow2Tag(row2Item)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select2RowItem?.Id === row2Item.Id?'eachTagActive':'']"
             style="margin-left: 6px;" v-for="row2Item in row2TagInfos" :key="row2Item.Id">
          {{ row2Item.Name }}
        </div>
      </div>
    </div>
    <div v-if="row3TagInfos!==null" style="margin:4px 0;"/>
    <div v-if="row3TagInfos!==null" style="display:flex;flex-direction: row;">
      <div @click="pressRow3Tag(null)" :class="[HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag',select3RowItem === null?'eachTagActive':'']">全部</div>
      <div class="scrollable-tags">
        <div @click="pressRow3Tag(row3Item)" :style="isInSelect3Row(row3Item['Id'])?{
              color: hcf.getMainColor(),
            backgroundColor: hcf.getMainColor() + '1a',
            border: `${hcf.getMainColor()} 1px solid`,
        }:{}" :class="HNewGameUIConfig.newGameUIType === 3?'eachTagDark':'eachTag'"
             style="margin-left: 6px;" v-for="row3Item in row3TagInfos" :key="row3Item.Id">
          {{ row3Item.Name }}

          <div v-if="isInSelect3Row(row3Item['Id'])"
               style="position:absolute;border-top-left-radius:10px;width:12px;height:12px;right:0;bottom:0;background-color: var(--ct-main-color)">
          </div>
          <div v-if="isInSelect3Row(row3Item['Id'])" style="position:absolute;right:0;bottom:-5px;">
            <van-icon name="success" style="color:white;" size="10px"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useHHttp} from "@/hooks/useHHttp.js";
  import {useUserStore} from "@/stores/useUser.js";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {watch} from "vue";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  let useHttp = useHHttp();
  let useUser = useUserStore();
  let isShowTagFilter = ref(false);

  let allTagInfos = ref([]);
  const select1RowItem = ref(null);
  const select2RowItem = ref(null);
  const select3RowItem = ref(null);
  const row2TagInfos = ref([]);
  const row3TagInfos = ref([]);

  const props = defineProps(["reqPath", "startSecs", "endSecs", "change"]);


  function pressRow1Tag(rowItem) {
    if (rowItem) {
      select1RowItem.value = rowItem;
      getAllRow23Infos(1);
    } else {
      select1RowItem.value = null;
      getAllRow23Infos(0);
    }
    select2RowItem.value = null;
    select3RowItem.value = null;

    props.change(select1RowItem.value, select2RowItem.value, getSelect3RowItemIds());
  }

  function pressRow2Tag(rowItem) {
    if (rowItem) {
      select2RowItem.value = rowItem;
      getAllRow23Infos(2);
    } else {
      select2RowItem.value = null;
      getAllRow23Infos(0);
    }
    select3RowItem.value = null;
    props.change(select1RowItem.value, select2RowItem.value, getSelect3RowItemIds());
  }


  function isInSelect3Row(itemId) {
    if (select3RowItem.value === null) {
      return false;
    }
    for (let i = 0; i < select3RowItem.value.length; i++) {
      if (select3RowItem.value[i]["Id"] === itemId) {
        return true;
      }
    }
    return false;
  }

  function pressRow3Tag(rowItem) {
    if (rowItem) {
      if (select3RowItem.value == null) {
        select3RowItem.value = [rowItem];
      } else {
        if (isInSelect3Row(rowItem["Id"])) {
          if (select3RowItem.value.length === 1) {
            select3RowItem.value = null;
          } else {
            hcf.removeObjByList(select3RowItem.value, rowItem);
          }
        } else {
          select3RowItem.value.push(rowItem);
        }
      }
    } else {
      select3RowItem.value = null;
    }
    props.change(select1RowItem.value, select2RowItem.value, getSelect3RowItemIds());
  }

  function getSelect3RowItemIds() {
    if (select3RowItem.value == null) {
      return [];
    }
    let ids = [];
    for (let i = 0; i < select3RowItem.value.length; i++) {
      ids.push(select3RowItem.value[i]["Id"]);
    }
    return ids;
  }

  watch(() => [props.startSecs, props.endSecs], async () => {
    updateTags();
  });

  //type=0 更新二级和三级
  //type=1 根据选择的1级更新二级和三级
  //type=2 根据选择1级和2级更新三级
  function getAllRow23Infos(type = 0) {
    if(type !== 2){
      row2TagInfos.value = [];
    }
    row3TagInfos.value = [];
    for (let i = 0; i < allTagInfos.value.length; i++) {
      let child1Array = allTagInfos.value[i]["Child"];
      for (let j = 0; j < child1Array.length; j++) {
        if(type === 1 && select1RowItem.value["Id"] !== allTagInfos.value[i]["Id"]){
          continue;
        }
        if(type !== 2){
          row2TagInfos.value.push(child1Array[j]);
        }

        let child2Array = child1Array[j]["Child"];
        for (let k = 0; k < child2Array.length; k++) {
          if(type === 2 && select2RowItem.value["Id"] !== child1Array[j]["Id"]){
            continue;
          }
          row3TagInfos.value.push(child2Array[k]);
        }
      }
    }
  }

  function updateTags() {
    useHttp.request(props.reqPath, (data) => {
      allTagInfos.value = data["Data"] ?? [];

      row2TagInfos.value = null;
      row3TagInfos.value = null;
      select1RowItem.value = null;
      select2RowItem.value = null;
      select3RowItem.value = null;


      if (allTagInfos.value.length > 0) {
        isShowTagFilter.value = true;
        getAllRow23Infos();
        select1RowItem.value = null;
        select2RowItem.value = null;
        select3RowItem.value = null;
      }
    }, {
      params: {
        "UserId": useUser.userId,
        "BeginTime": props.startSecs,
        "EndTime": props.endSecs,
      }
    });
  }


  onMounted(() => {
    updateTags();
  });
</script>


<style scoped>
  .tDoubleTagsParentDiv {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
  }

  .scrollable-tags {
    display: flex;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* iOS 流畅滚动 */
  }
  .eachTagDark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    background-color: #333;
    font-size: 13px;
    color: #aaa;
    border-radius: 3px;
    flex-shrink: 0;
  }
  .eachTag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 3px 10px;
    background-color: #e8e8e8;
    font-size: 13px;
    color: #444;
    border-radius: 3px;
    flex-shrink: 0;
    border: #0000 1px solid;
    position: relative;
  }

  .eachTagActive {
    background-color: var(--ct-main-color);
    color: white;
  }

</style>
